import { inject, observer } from 'mobx-react';
import useLanguageChange from '../../utils/hooks/useLanguageChange';
import StatementImportsSection from './StatementImportsSection';

// Keep the complete import/review workflow on its own credit-card page.
const ReconciliationPage = ({ data }) => {
  useLanguageChange(data.t);
  return (
    <div className='card p-1 mt-2 rounded-lg'>
      <StatementImportsSection data={data} />
    </div>
  );
};

export default inject('data')(observer(ReconciliationPage));
